<template>
  <div>
    <h3>Selecciona un tipo de tarjeta para tu producto</h3>
    <div class="m-edition-product-card-design-selection">
      <a
        v-for="i in cardNumbers"
        :key="i"
        href="#"
        @click.prevent="changeCardType(i)"
      >
        <MoleculeFeedSectionContentCardDesign
          :is="`MoleculeFeedSectionContentCardDesign${i}`"
          :element="productoInicial"
          :element-categorias="elementCategorias"
          :show-selected="showSelected"
          @changeCardType="changeCardType"
        />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionProductCardTypes',

  components: {
    MoleculeFeedSectionContentCardDesign2: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign2'),
    MoleculeFeedSectionContentCardDesign3: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign3'),
    MoleculeFeedSectionContentCardDesign4: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign4'),
    MoleculeFeedSectionContentCardDesign5: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign5'),
    MoleculeFeedSectionContentCardDesign6: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign6'),
    MoleculeFeedSectionContentCardDesign7: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign7')
  },

  props: {
    element: Object,
    elementCategorias: Array
  },

  data () {
    return {
      cardNumbers: [2, 3, 4, 5, 6, 7],
      productoInicial: {},
      showSelected: true
    }
  },

  created () {
    this.productoInicial = this.$store.getters.getCardData
  },

  methods: {
    changeCardType (cardType) {
      this.$store.commit('setCardType', cardType)
      this.$router.push(`/${this.$t('rPaths.product')}/${this.$route.params.id}/${this.$route.params.subject}`)
    }
  }
}
</script>
